import { formatTimeStamp } from "../../api/callData";
import { Icon } from "@iconify/react/dist/iconify.js";

import { getOrderStatusColor, getOrderStatusStyles } from "../../utils/orderUtils";
import ReviewStatusIndicator from "./ReviewStatusIndicator";


const OrdersTable = ({
    paginatedOrders,
    selectedOrder,
    searchParams,
    setSelectedOrder,
    rowRef,
    getEquipmentList,
    getOrderStatus,
    getTotalAmount
}) => {
    const handleOrderClick = (order) => {
        // Add to browser history when opening order details
        const newParams = new URLSearchParams(searchParams);
        newParams.set('id', order.cart_data?.summary?.cart_id || order.booking_info?.booking_status?.booking_id || order.id);
        window.history.pushState({}, '', `?${newParams.toString()}`);
        setSelectedOrder(order);
    };

    console.log('selectedOrder', selectedOrder);

    return (
        <>
            <div className="flex-shrink-0 hidden md:block">
                <table className="w-full table-auto text-left border-collapse text-sm">
                    <thead>
                        <tr className="text-font-primary h-[48px] rounded-md card-container font-semibold">
                            <th className="w-[120px] max-w-[120px] lg:w-[150px] lg:max-w-[150px] truncate pl-4 pr-2">Equipment</th>
                            <th className="w-[50px] max-w-[50px] lg:w-[80px] lg:max-w-[80px] truncate pr-2">Phone Number</th>
                            <th className="w-[30px] lg:w-[50px] truncate max-w-[50px] lg:max-w-[50px] pr-2">Timestamp</th>
                            {!selectedOrder && (
                                <th className="w-[50px] max-w-[50px] lg:w-[80px] lg:max-w-[80px] truncate pr-2">Order ID</th>
                            )}
                            {!selectedOrder && (
                                <th className="w-[50px] max-w-[50px] lg:w-[80px] lg:max-w-[80px] truncate pr-2">Booking Status</th>
                            )}
                            <th className="w-[50px] max-w-[50px] lg:w-[80px] lg:max-w-[80px] truncate pr-4">Total</th>
                            {!selectedOrder && (
                                <th className="w-[20px] max-w-[20px] lg:w-[30px] lg:max-w-[30px] truncate pr-2">Review</th>
                            )}
                        </tr>
                    </thead>
                </table>
            </div>
            
            <div className="flex-1 overflow-y-auto scrollable hidden md:block">
                <table className="w-full table-auto text-left border-collapse text-sm">
                    <tbody>
                        {paginatedOrders.map((order, index) => {
                            const ref = index === 0 ? rowRef : null;
                            return (
                                <tr
                                    key={order.cart_data?.summary?.cart_id || order.booking_info?.booking_status?.booking_id || order.id}
                                    ref={ref}
                                    className={`h-[56px] border-b border-border group text-font-secondary interactive-card-container cursor-pointer transition-all ease-out-in duration-300
                                        ${(selectedOrder?.cart_data?.summary?.cart_id || selectedOrder?.booking_info?.booking_status?.booking_id || selectedOrder?.id) === (order.cart_data?.summary?.cart_id || order.booking_info?.booking_status?.booking_id || order.id) ? 'bg-primary-20 border-primary-50 border' : ''}`}
                                    onClick={() => handleOrderClick(order)}
                                >
                                    <td className={`w-[120px] max-w-[120px] lg:w-[150px] lg:max-w-[150px] group-hover:font-bold truncate font-semibold pl-4 pr-2 ${getEquipmentList(order.cart_data || order.booking_info).startsWith('Equipment') ? 'text-font-secondary' : 'text-font-primary'}`}>
                                        {getEquipmentList(order.cart_data || order.booking_info)}
                                    </td>
                                    <td className="w-[50px] max-w-[50px] lg:w-[80px] lg:max-w-[80px] group-hover:text-primary truncate pr-2">
                                        {order.metadata?.caller_id || 'N/A'}
                                    </td>
                                    <td className="w-[30px] lg:w-[50px] group-hover:text-primary truncate max-w-[50px] pr-2">
                                        {formatTimeStamp(order.metadata?.timestamp)}
                                    </td>
                                    {!selectedOrder && (
                                        <td className={`w-[50px] max-w-[50px] lg:w-[80px] lg:max-w-[80px] truncate pr-2 ${(order.cart_data?.summary?.cart_id || order.booking_info?.booking_status?.booking_id) ? 'text-font-primary' : 'text-font-secondary'}`}>
                                            {(order.cart_data?.summary?.cart_id || order.booking_info?.booking_status?.booking_id) ? `#${order.cart_data?.summary?.cart_id || order.booking_info?.booking_status?.booking_id}` : 'N/A'}
                                        </td>
                                    )}
                                    {!selectedOrder && (
                                        <td className="w-[50px] max-w-[50px] lg:w-[80px] lg:max-w-[80px] truncate pr-2">
                                            {(() => {
                                                const status = getOrderStatus(order.cart_data || order.booking_info, order.booking_resolved);
                                                const { icon, className } = getOrderStatusStyles(status, order.booking_resolved);
                                                return (
                                                    <div className={`w-fit font-semibold p-1.5 rounded text-xs flex items-center gap-0.5 text-font-primary justify-center ${className}`}>
                                                        <Icon icon={icon} className="text-sm sm:text-base" />
                                                        <span className="text-font-primary">{status}</span>
                                                    </div>
                                                );
                                            })()}
                                        </td>
                                    )}
                                    <td className={`w-[50px] max-w-[50px] lg:w-[80px] lg:max-w-[80px] truncate pr-4 ${getTotalAmount(order.cart_data || order.booking_info).startsWith('$') ? 'font-semibold text-primary' : 'text-font-secondary'}`}>
                                        {getTotalAmount(order.cart_data || order.booking_info)}
                                    </td>
                                    {!selectedOrder && (
                                        <td className="w-[20px] max-w-[20px] lg:w-[30px] lg:max-w-[30px] truncate pr-2">
                                            <ReviewStatusIndicator order={order} compact={true} />
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default OrdersTable;
